import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { FIREBASE_AUTH } from '../firebase/firebase.providers';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const { currentUser } = inject(FIREBASE_AUTH);

  if (!currentUser) {
    return next(req);
  }

  // getIdToken() returns the cached token if still valid, or transparently
  // fetches a new one from Firebase when the current token is expired.
  return from(currentUser.getIdToken()).pipe(
    switchMap((token) => {
      const authedReq = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
      return next(authedReq);
    }),
  );
};
